/* LevelUp 2027 (Night Drop Valkoinen): size finder, product tabs, UGC clips.
   Same size formula as the product page fit finder (lu-product.liquid). */
(function () {
  'use strict';

  var EASE_OUT = 'cubic-bezier(0.23, 1, 0.32, 1)';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- size formula (copy of FF_PROFILES in lu-product.liquid) ---------- */
  var PROFILES = {
    oversized_hoodie: { sizes: ['S','M','L','XL','XXL','XXXL'], t: [72,85,96,108,132], hf: .80, shift: { fit: -8, normal: 0, baggy: 9 }, floor: [[187,'L'],[195,'XL']] },
    oversized_tshirt: { sizes: ['S','M','L','XL','XXL','XXXL'], t: [70,82,94,106,122], hf: .72, shift: { fit: -7, normal: 0, baggy: 8 }, floor: [[188,'L'],[196,'XL']] },
    jersey_gc: { sizes: ['XS','S','M','L','XL','2XL'], t: [62,72,83,95,108], hf: .70, shift: { fit: -6, normal: 0, baggy: 7 }, floor: [[184,'L'],[191,'XL']] },
    hn_hoodie: { sizes: ['XS','S','M','L','XL','XXL'], t: [63,73,84,96,109], hf: .72, shift: { fit: -6, normal: 0, baggy: 7 }, floor: [[184,'L'],[191,'XL']] },
    cropped_zip: { sizes: ['XS','S','M','L','XL','XXL'], t: [62,72,83,95,108], hf: .78, shift: { fit: -5, normal: 0, baggy: 6 }, floor: [[178,'M'],[185,'L'],[191,'XL']] },
    silence_jacket: { sizes: ['XS','S','M','L','XL','2XL','3XL','4XL'], t: [61,70,80,91,103,116,132], hf: .82, shift: { fit: -5, normal: 0, baggy: 6 }, floor: [[176,'M'],[182,'L'],[188,'XL'],[194,'2XL']] },
    pants: { sizes: ['XS','S','M','L','XL','XXL'], t: [61,70,81,93,107], hf: .62, shift: { fit: -2, normal: 0, baggy: 4 }, floor: [[178,'M'],[185,'L'],[192,'XL']] },
    silence_pants: { sizes: ['XS','S','M','L','XL','2XL','3XL','4XL'], t: [60,69,79,90,102,115,132], hf: .62, shift: { fit: -2, normal: 0, baggy: 4 }, floor: [[176,'M'],[182,'L'],[188,'XL'],[194,'2XL']] }
  };
  var SETS = {
    tracksuit: { top: 'cropped_zip', bottom: 'pants' },
    tracksuit_silence: { top: 'silence_jacket', bottom: 'silence_pants' }
  };
  /* chart types that have no profile of their own use the closest one */
  var ALIAS = { oversized_hoodie: 'oversized_hoodie', oversized_tshirt: 'oversized_tshirt', silence_jacket: 'silence_jacket', silence_pants: 'silence_pants' };

  function norm(s) { return String(s || '').trim().toUpperCase().replace(/^XXXL$/, '3XL').replace(/^XXL$/, '2XL'); }
  function idx(list, s) { var n = norm(s); for (var i = 0; i < list.length; i++) if (norm(list[i]) === n) return i; return -1; }
  function rec(key, h, w, fit) {
    var p = PROFILES[ALIAS[key] || key];
    if (!p) return null;
    var score = w + p.hf * (h - 170) + (p.shift[fit] || 0), i = 0;
    while (i < p.t.length && score >= p.t[i]) i++;
    var floor = -1;
    p.floor.forEach(function (r) { if (h >= r[0]) floor = Math.max(floor, idx(p.sizes, r[1])); });
    if (fit === 'fit' && floor > 0) floor--;
    i = Math.max(i, floor);
    return p.sizes[Math.max(0, Math.min(p.sizes.length - 1, i))];
  }
  function profileSizes(key) { var p = PROFILES[ALIAS[key] || key]; return p ? p.sizes : []; }

  function swapIn(el, text) {
    if (el.textContent === text) return;
    el.textContent = text;
    if (reduce || !el.animate) return;
    el.animate(
      [{ opacity: 0.35, filter: 'blur(2px)', transform: 'translateY(4px)' }, { opacity: 1, filter: 'blur(0)', transform: 'none' }],
      { duration: 200, easing: EASE_OUT }
    );
  }

  /* ---------- Mikä koko? ---------- */
  function initFinder(root) {
    if (root.__l7) return; root.__l7 = true;
    var dataEl = root.querySelector('[data-l7-products]');
    if (!dataEl) return;
    var products;
    try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!products.length) return;

    var t = root.dataset;
    var h = root.querySelector('[data-h]'), w = root.querySelector('[data-w]');
    var hv = root.querySelector('[data-hv]'), wv = root.querySelector('[data-wv]');
    var seg = root.querySelector('[data-seg]');
    var sizeEl = root.querySelector('[data-size]'), noteEl = root.querySelector('[data-note]');
    var idInput = root.querySelector('[data-variant-id]'), addBtn = root.querySelector('[data-add]');
    var addLabel = root.querySelector('[data-add-label]'), altLink = root.querySelector('[data-alt]');
    var form = root.querySelector('[data-form]');
    var current = 0, fit = 'normal';

    function roles(p) {
      var r = { single: -1, top: -1, bottom: -1 };
      p.options.forEach(function (name, i) {
        var n = String(name).toLowerCase();
        if (/housu|pants|bottom|alaosa/.test(n)) r.bottom = i;
        else if (/takki|jacket|hoodie|top|yläosa|ylaosa/.test(n)) r.top = i;
        if (/koko|size/.test(n) && r.single < 0) r.single = i;
      });
      if (r.single < 0) {
        for (var i = 0; i < p.options.length; i++) { if (i !== r.top && i !== r.bottom) { r.single = i; break; } }
        if (r.single < 0) r.single = 0;
      }
      return r;
    }

    /* find the variant for wanted sizes; if sold out, the nearest one in stock */
    function pick(p, wantedByOpt, keysByOpt) {
      var best = null, bestD = 1e9, exact = null;
      p.variants.forEach(function (v) {
        var d = 0, ok = true;
        for (var oi in wantedByOpt) {
          var sizes = profileSizes(keysByOpt[oi]);
          var a = idx(sizes, wantedByOpt[oi]), b = idx(sizes, v.options[oi]);
          if (b < 0) { if (norm(v.options[oi]) !== norm(wantedByOpt[oi])) { ok = false; break; } b = a; }
          d += Math.abs(a - b);
        }
        if (!ok) return;
        if (d === 0 && !exact) exact = v;
        if (v.available && d < bestD) { bestD = d; best = v; }
      });
      return { exact: exact, best: best };
    }

    function label(p, v, r) {
      if (p.set) return t.labelTop + ' ' + v.options[r.top] + ', ' + t.labelBottom.toLowerCase() + ' ' + v.options[r.bottom];
      return t.labelSize + ' ' + v.options[r.single];
    }

    function update() {
      var p = products[current];
      var H = +h.value, W = +w.value;
      hv.textContent = H; wv.textContent = W;
      h.style.setProperty('--p', ((H - h.min) / (h.max - h.min) * 100) + '%');
      w.style.setProperty('--p', ((W - w.min) / (w.max - w.min) * 100) + '%');

      var r = roles(p), wanted = {}, keys = {}, text;
      var set = SETS[p.chart];
      p.set = !!set && r.top >= 0 && r.bottom >= 0;
      if (p.set) {
        wanted[r.top] = rec(set.top, H, W, fit); keys[r.top] = set.top;
        wanted[r.bottom] = rec(set.bottom, H, W, fit); keys[r.bottom] = set.bottom;
        text = t.labelTop + ' ' + wanted[r.top] + ', ' + t.labelBottom.toLowerCase() + ' ' + wanted[r.bottom];
      } else {
        var key = PROFILES[p.chart] ? p.chart : (set ? set.top : 'hn_hoodie');
        wanted[r.single] = rec(key, H, W, fit); keys[r.single] = key;
        /* some models run big or small: move the answer one size down or up */
        if (p.offset) {
          var ps = profileSizes(key), k = idx(ps, wanted[r.single]);
          if (k > -1) wanted[r.single] = ps[Math.max(0, Math.min(ps.length - 1, k + p.offset))];
        }
        if (p.chart === 'oversized_hoodie' || p.chart === 'oversized_tshirt') {
          wanted[r.single] = String(wanted[r.single]).replace(/^2XL$/, 'XXL').replace(/^3XL$/, 'XXXL');
        }
        text = t.labelSize + ' ' + wanted[r.single];
      }
      swapIn(sizeEl, text);

      var res = pick(p, wanted, keys);
      var v = res.exact && res.exact.available ? res.exact : res.best;
      if (res.exact && res.exact.available) {
        noteEl.textContent = t.noteOk;
      } else if (res.best) {
        noteEl.innerHTML = '';
        noteEl.appendChild(document.createTextNode(t.noteOut + ' '));
        var s = document.createElement('strong'); s.textContent = label(p, res.best, r); noteEl.appendChild(s);
      } else {
        noteEl.textContent = t.noteNone;
      }

      if (v) {
        idInput.value = v.id;
        addBtn.disabled = false;
        addLabel.textContent = t.addLabel.replace('[price]', v.price);
        altLink.href = p.url + (p.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id;
      } else {
        idInput.value = '';
        addBtn.disabled = true;
        addLabel.textContent = t.soldOut;
        altLink.href = p.url;
      }
    }

    /* product chips */
    var chips = root.querySelectorAll('[data-pchip]');
    var items = root.querySelectorAll('[data-pitem]');
    chips.forEach(function (c, i) {
      c.addEventListener('click', function () {
        if (current === i) return;
        current = i;
        chips.forEach(function (x, j) { x.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        var row = c.parentNode;
        if (row && row.scrollWidth > row.clientWidth) {
          var l = c.offsetLeft - row.offsetLeft, rr = l + c.offsetWidth;
          if (l < row.scrollLeft + 16) row.scrollTo({ left: Math.max(0, l - 16), behavior: reduce ? 'auto' : 'smooth' });
          else if (rr > row.scrollLeft + row.clientWidth - 40) row.scrollTo({ left: rr - row.clientWidth + 40, behavior: reduce ? 'auto' : 'smooth' });
        }
        items.forEach(function (it, j) { it.hidden = j !== i; });
        update();
      });
    });

    /* product carousel: edge fades + arrows (arrows show on desktop) */
    var row = root.querySelector('.l7-fit__products');
    var prev = root.querySelector('[data-chips-prev]'), next = root.querySelector('[data-chips-next]');
    function edges() {
      if (!row) return;
      var max = row.scrollWidth - row.clientWidth;
      var atStart = row.scrollLeft <= 2, atEnd = row.scrollLeft >= max - 2;
      row.toggleAttribute('data-mid', !atStart);
      row.toggleAttribute('data-end', atEnd);
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }
    if (row) {
      row.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges);
      edges();
      [[prev, -1], [next, 1]].forEach(function (pair) {
        if (!pair[0]) return;
        pair[0].addEventListener('click', function () {
          row.scrollBy({ left: pair[1] * row.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    }

    /* fit segmented control (radio group, arrow keys move) */
    var segBtns = seg.querySelectorAll('button');
    function setFit(i, focus) {
      segBtns.forEach(function (b, j) {
        b.setAttribute('aria-checked', j === i ? 'true' : 'false');
        b.tabIndex = j === i ? 0 : -1;
      });
      seg.style.setProperty('--i', i);
      fit = segBtns[i].dataset.fit;
      if (focus) segBtns[i].focus();
      update();
    }
    segBtns.forEach(function (b, i) {
      b.addEventListener('click', function () { setFit(i); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); setFit((i + 1) % segBtns.length, true); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); setFit((i - 1 + segBtns.length) % segBtns.length, true); }
      });
    });

    h.addEventListener('input', update);
    w.addEventListener('input', update);

    /* add to cart: use the theme's cart drawer when there is one, else go to the cart */
    form.addEventListener('submit', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
      e.preventDefault();
      if (!idInput.value) return;
      addBtn.disabled = true;
      var body = new FormData(form);
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { noteEl.textContent = res.description || res.message || t.noteNone; return; }
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        })
        .catch(function () { form.submit(); })
        .finally(function () { addBtn.disabled = false; });
    });

    update();
  }

  /* ---------- Kaikki tuotteet ---------- */
  function initTabs(root) {
    if (root.__l7) return; root.__l7 = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = tabs.map(function (tb) { return document.getElementById(tb.getAttribute('aria-controls')); });

    function show(i, focus) {
      tabs.forEach(function (tb, j) {
        var on = j === i;
        tb.setAttribute('aria-selected', on ? 'true' : 'false');
        tb.tabIndex = on ? 0 : -1;
        if (panels[j]) panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
      /* keep the chosen chip in view on phones */
      var bar = tabs[i].parentNode;
      if (bar.scrollWidth > bar.clientWidth) {
        var left = tabs[i].offsetLeft - 16;
        bar.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
      }
      if (reduce || !panels[i]) return;
      var cards = panels[i].querySelectorAll('.l7-grid > li');
      for (var k = 0; k < cards.length && k < 8; k++) {
        if (!cards[k].animate) break;
        cards[k].animate(
          [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }],
          { duration: 240, delay: k * 35, easing: EASE_OUT, fill: 'backwards' }
        );
      }
    }

    tabs.forEach(function (tb, i) {
      tb.addEventListener('click', function () { if (tb.getAttribute('aria-selected') !== 'true') show(i); });
      tb.addEventListener('keydown', function (e) {
        var n = tabs.length, j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % n;
        if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
        if (e.key === 'Home') j = 0;
        if (e.key === 'End') j = n - 1;
        if (j !== null) { e.preventDefault(); show(j, true); }
      });
    });
  }


  /* ---------- UGC clips: play when visible, one with sound at a time ---------- */
  function initUgc(root) {
    if (root.__l7) return; root.__l7 = true;
    var vids = Array.prototype.slice.call(root.querySelectorAll('video'));
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.preload = 'auto'; var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
          else e.target.pause();
        });
      }, { threshold: .5 });
      vids.forEach(function (v) { io.observe(v); });
    }
    root.querySelectorAll('[data-snd]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.parentNode.querySelector('video'); if (!v) return;
        vids.forEach(function (o) { if (o !== v) { o.muted = true; var ob = o.parentNode.querySelector('[data-snd]'); if (ob) ob.textContent = b.dataset.on; } });
        v.muted = !v.muted; if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        b.textContent = v.muted ? b.dataset.on : b.dataset.off;
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-l7-finder]').forEach(initFinder);
    (scope || document).querySelectorAll('[data-l7-tabs]').forEach(initTabs);
    (scope || document).querySelectorAll('[data-l7-ugc]').forEach(initUgc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  /* theme editor: re-init when a section is added or changed */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
